import React from 'react';
import { Box, Typography } from '@mui/material';
import { NotificationsOff } from '@mui/icons-material';

const EmptyState = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60vh',
        gap: 3,
        p: 4,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          p: 4,
          borderRadius: 3,
          backgroundColor: '#f8f9fa',
          border: '2px dashed #9291f0',
          maxWidth: '400px',
          textAlign: 'center',
        }}
      >
        <NotificationsOff
          sx={{
            fontSize: '4rem',
            color: '#9291f0',
            opacity: 0.7,
          }}
        />
        <Typography
          variant='h5'
          sx={{
            fontFamily: 'Lato',
            fontWeight: 700,
            color: '#333',
            mb: 1,
          }}
        >
          No Reminders Yet
        </Typography>
        <Typography
          variant='body1'
          sx={{
            fontFamily: 'Lato',
            color: '#666',
            lineHeight: 1.6,
            maxWidth: '300px',
          }}
        >
          You haven't created any reminders yet. Start by creating your first reminder to stay organized and on track.
        </Typography>
      </Box>
    </Box>
  );
};

export default EmptyState;
